import { ComponentDataFilterService, FilterFunction } from '../../component-data-filter/component-data-filter.service';
import { DistanceFilter } from '../../events-filter/events-filter.model';

/**
 * Interface for the events filter (legacy + extended fields).
 */
export interface EventsFilter {
  eventType: string[];
  dateRange: {
    start: Date | null;
    end: Date | null;
  };
  visibility: string[];
  searchText?: string;
  organizationIds?: number[];
  hideSubEvents?: boolean;
  educationalPathIds?: number[];
  educationalPathVersionIds?: number[];
  moduleIds?: number[];
  locationGuids?: string[];
  hideFullEvents?: boolean;
  hideParticipatedEvents?: boolean;
  showGroupCalendarEvents?: boolean;
  distanceFilter?: DistanceFilter;
}

export function events_filter(filterService: ComponentDataFilterService): FilterFunction {
  const defaultFilter: EventsFilter = {
    eventType: [],
    dateRange: { start: null, end: null },
    visibility: [],
    searchText: '',
    organizationIds: [],
    hideSubEvents: true,
    educationalPathIds: [],
    educationalPathVersionIds: [],
    moduleIds: [],
    locationGuids: [],
    hideFullEvents: false,
    hideParticipatedEvents: false,
    showGroupCalendarEvents: false,
    distanceFilter: {
      enabled: false,
      latitude: null,
      longitude: null,
      radiusKm: null,
    },
  };

  return filterService.createFilter(
    'Events Filter',
    'Filter for events calendar',
    defaultFilter,
    'debouncing',
    500
  );
}

export function registerEventsFilter(filterService: ComponentDataFilterService): void {
  const filter = events_filter(filterService);
  filterService.registerFilter('events-filter', filter);
}
